import icon from 'assets/icons/chart.svg';
import React, {Component, PureComponent} from 'react';
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import './BalanceAndRwa.style.scss';

export default class BalanceAndRwa extends Component {
  render() {
    const data = [
      {branch: 'HA NOI', Outstanding: 8767012, RWA: 5917733.1, RAROC: 20},
      {branch: 'HO CHI MINH', Outstanding: 6232918.8, RWA: 4207226.69, RAROC: 19},
      {branch: 'BAC NINH', Outstanding: 4533913, RWA: 3060391.8, RAROC: 21},
      {branch: 'THAI NGUYEN', Outstanding: 408000, RWA: 275400, RAROC: 20},
      {branch: 'HAI PHONG', Outstanding: 1913800, RWA: 1291815, RAROC: 18},
      {branch: 'BINH DUONG', Outstanding: 808620, RWA: 545818, RAROC: 18},
      {branch: 'DONG NAI', Outstanding: 7132786, RWA: 4814630.17, RAROC: 24},
      {branch: 'HA NAM', Outstanding: 2867213.9, RWA: 1935369.383, RAROC: 19},
      {branch: 'DA NANG', Outstanding: 645138, RWA: 435468.15, RAROC: 22},
      {branch: 'BIEN HOA', Outstanding: 1935486.2, RWA: 1306453.185, RAROC: 19},
      {branch: 'SAI GON', Outstanding: 3200000, RWA: 4800000, RAROC: 24},
      {branch: 'VINH PHUC', Outstanding: 296610, RWA: 200211.75, RAROC: 18},
      {branch: 'HOAN KIEM', Outstanding: 446200, RWA: 301185, RAROC: 21},
      {branch: 'PHU MY HUNG', Outstanding: 623341.8, RWA: 701259.525, RAROC: 19},
    ];

    return (
      <div className='BalanceAndRwacontainer'>
        <h1 className='BalanceAndRwatitle'>
          <img src={icon} alt='' style={{marginRight: 8}} />
          BALANCE AND RWA by BRANCH
        </h1>
        <ResponsiveContainer width='100%' height={300}>
          <ComposedChart height={300} data={data}>
            <XAxis
              dataKey='branch'
              axisLine={false}
              tickLine={false}
              tick={<CustomizedAxisTick />}
            />

            <YAxis yAxisId={2} hide domain={[0, 100]} />
            <YAxis yAxisId={1} axisLine={false} tickLine={false} />
            <CartesianGrid yAxis={{hide: true}} />
            <Bar yAxisId={1} dataKey='Outstanding' barSize={50} fill='#FBC83A' radius={8} />
            <Bar yAxisId={1} dataKey='RWA' barSize={50} fill='#EBEBEB' radius={8} />
            <Line yAxisId={2} dataKey='RAROC' stroke='#C50F2F' strokeWidth={2} />
            <Legend
              wrapperStyle={{
                paddingTop: '20px',
              }}
            />
            <Tooltip cursor={false} content={<CustomTooltip />} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

class CustomizedAxisTick extends PureComponent {
  render() {
    const {x, y, payload} = this.props;

    return (
      <text x={x} y={y} dy={24} fill='#0B0B0A' textAnchor='middle' fontSize={14}>
        <tspan>{payload.value}</tspan>
      </text>
    );
  }
}

const CustomTooltip = (props) => {
  const {active, payload} = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;

    return (
      <div className='custom-tooltip'>
        <div className='name'>{item.branch}</div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#fbc83a'}} />
          <div className='desc'>{item.Outstanding}</div>
        </div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#EBEBEB'}} />
          <div className='desc'>{item.RWA}</div>
        </div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#C50F2F'}} />
          <div className='desc'>{item.RAROC}%</div>
        </div>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewByBranch/components/BalanceAndRwa/BalanceAndRwa.js